import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import ContactUs from './pages/ContactUs';
import AboutUs from './pages/AboutUs';
import About from './pages/About';

import Navbar from './components/ArtisttoHeader';
import ArtisttoFooter from './components/ArtisttoFooter';
import './App.css';
import MusicMarketing from './pages/MusicMarketing';
import FloatingWhatsApp from './components/FloatingWhatsApp';
function Layout({ children }) {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <ArtisttoFooter />
    </>
  );
}
function App() {
  return (
    <Router>
      {/* <Layout> */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/audio-video-production" element={<AboutUs/>} />
          <Route path="/music-marketing" element={<MusicMarketing />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/contact" element={<ContactUs />} />
        </Routes>
      {/* </Layout> */}
      <FloatingWhatsApp phone={'+917217679356'} message="Hi, i want to know more." />
    </Router>
  );
}
export default App;
